import { makeStyles } from "@material-ui/core";

export const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  }
});
